import { useState } from 'react';
import { toast } from 'sonner';
import { useReturnVerification } from './useReturnVerification';

const COMMENT_REQUIRED = 'A comment is required to return a verification';

interface ReturnVerificationForm {
  comment: string;
  setComment: (comment: string) => void;
  error: string | null;
  isLoading: boolean;
  submit: () => void;
}

export function useReturnVerificationForm(
  verificationId: string,
  onDone: () => void
): ReturnVerificationForm {
  const [comment, setComment] = useState('');
  const [error, setError] = useState<string | null>(null);
  const { returnVerification, isLoading } = useReturnVerification();

  const submit = (): void => {
    if (!comment.trim()) {
      setError(COMMENT_REQUIRED);
      return;
    }
    setError(null);
    returnVerification(
      { verificationId, comment: comment.trim() },
      {
        onSuccess: () => {
          toast.success('Verification returned to the agent');
          onDone();
        },
        onError: () => toast.error('Failed to return the verification'),
      }
    );
  };

  return { comment, setComment, error, isLoading, submit };
}
